/**
 * Get CSRF token from cookies
 * This function extracts the CSRF token from document.cookie
 */
export function getCSRFToken() {
  const name = 'csrftoken';
  let cookieValue = null;
  
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  
  return cookieValue || '';
}

/**
 * Alternative method to get CSRF token from meta tag
 * If your Django app sets CSRF token in a meta tag, use this instead
 */
export function getCSRFTokenFromMeta() {
  const metaTag = document.querySelector('meta[name="csrf-token"]');
  return metaTag ? metaTag.getAttribute('content') : '';
}

